import { createSlice } from "@reduxjs/toolkit";
import { sortAllView } from "../utils";
import { boardViewForAllocation } from "./TransferOrderSliceV2";

const warehouseCostingRangeDefaultColumns = [
  "PRODUCT",
  "SUPPLIER",
  "FROM FACILITY",
  "TO FACILITY",
  "FROM QUANTITY",
  "TO QUANTITY",
  "PRICE",
  "CREATED BY",
  "CREATE DATE",
];
const stockZoneDefaultColumns = ["NAME", "FACILITY", "TYPE", "CREATED BY", "CREATE DATE"];

const forecastsDefaultColumns = [
  "PRODUCT",
  "FACILITY",
  "FROM",
  "TO",
  "QUANTITY",
  "CREATED BY",
  "CREATE DATE",
];

const stockLocationDefaultColumns = [
  "NAME",
  "CODE",
  "STOCK ZONE",
  "FACILITY",
  "CREATED BY",
  "CREATE DATE",
];

const standardCostsDefaultColumns = [
  "PRODUCT",
  "FACILITY",
  "OTHER COSTS TYPE",
  "UNIT COST",
  "OTHER COSTS",
  "TOTAL LANDED COSTS",
  "CREATE DATE",
  "CREATED BY",
];

const warehouseCostingsDefaultColumns = [
  "PRODUCT",
  "SUPPLIER",
  "FROM FACILITY",
  "TO FACILITY",
  "FROM QUANTITY",
  "TO QUANTITY",
  "PRICE",
  "CREATED BY",
  "CREATE DATE",
];

const stockReplenishmentDefaultColumns = [
  "REPLENISH NO",
  "PRODUCT",
  "SUGGESTED QUANTITY",
  "CONFIRM QTY",
  "SOURCE LOCATIONS",
  "DESTINATION LOCATION",
  "FACILITY",
  "STATUS",
  "CREATED BY",
  "CREATE DATE",
];

const picklistDefaultColumns = [
  "PICKLIST NO",
  "SALES ORDERS",
  "CUSTOMERS",
  "FACILITY",
  "REQUESTED SHIP DATE",
  "PICK DATE",
  "TYPE",
  "STATUS",
];

const stockPackDefaultColumns = [
  "PACK NO",
  "CUSTOMER",
  "SUPPLY FACILITY",
  "SHIPPING ADDRESS",
  "PACKAGING TYPE",
  "PACK DATE",
  "DANGEROUS GOODS",
  "WEIGHT",
  "WEIGHT UNIT",
  "LENGTH",
  "WIDTH",
  "HEIGHT",
  "DIMENSION UOM",
  "CBM",
  "STATUS",
];

const siteDefaultColumns = [
  "CODE",
  "NAME",
  "TIME ZONE",
  "ADDRESS",
  "ACTIVE",
  "CREATED BY",
  "CREATE DATE",
];

const workCenterDefaultColumns = [
  "NAME",
  "TYPE",
  "CODE",
  "LOCATION",
  "FACILITY",
  "STOCK ZONE",
  "ACTIVE",
  "CREATED BY",
  "CREATE DATE",
];

const initialState = {
  boardView: "false",
  allViews: {
    listView: {
      nameOfViews: [],
      allItemsName: [
        "CATEGORY",
        "PRODUCT",
        "PRODUCT NAME",
        "FACILITY",
        "SELLABLE",
        "ALLOCATED",
        "RESERVED",
        "ON HOLD",
        "REJECTED",
        "TOTAL",
        "NSP",
        "AVG COST",
        "STOCK VALUE",
      ],
      allViews: {
        "Default View": [
          "PRODUCT NAME",
          "CATEGORY",
          "FACILITY",
          "SELLABLE",
          "ALLOCATED",
          "RESERVED",
          "ON HOLD",
          "REJECTED",
          "TOTAL",
          "NSP",
          "AVG COST",
          "STOCK VALUE",
        ],
      },
    },
    ...boardViewForAllocation,
    completeListOfViews: [],
  },

  warehouseCostingRangeLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: warehouseCostingRangeDefaultColumns,
      allViews: {
        "Default View": warehouseCostingRangeDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  stockZoneLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: stockZoneDefaultColumns,
      allViews: {
        "Default View": stockZoneDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  forecastLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: forecastsDefaultColumns,
      allViews: {
        "Default View": forecastsDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  stockLocationLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: stockLocationDefaultColumns,
      allViews: {
        "Default View": stockLocationDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  standardCostLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: standardCostsDefaultColumns,
      allViews: {
        "Default View": standardCostsDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  warehouseCostingLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: warehouseCostingsDefaultColumns,
      allViews: {
        "Default View": warehouseCostingsDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  stockReplenishmentLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: stockReplenishmentDefaultColumns,
      allViews: {
        "Default View": stockReplenishmentDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  picklistLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: picklistDefaultColumns,
      allViews: {
        "Default View": picklistDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  stockPackLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: stockPackDefaultColumns,
      allViews: {
        "Default View": stockPackDefaultColumns,
      },
      nameOfViews: [],
    },
  },

  siteLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: siteDefaultColumns,
      allViews: {
        "Default View": siteDefaultColumns,
      },
      nameOfViews: [],
    },
  },

  workCenterLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: workCenterDefaultColumns,
      allViews: {
        "Default View": workCenterDefaultColumns,
      },
      nameOfViews: [],
    },
  },

  stockPack: {},

  inventory: {
    inventory: {
      listView: {
        nameOfViews: [],
        allItemsName: [
          "CATEGORIES",
          "PRODUCT",
          "FACILITY",
          "SELLABLE",
          "ALLOCATED",
          "RESERVED",
          "ON HOLD",
          "REJECTED",
          "TOTAL",
          "INCOMING",
          "NSP",
          "AVG COST",
          "STOCK VALUE",
        ],
        allViews: {
          "Default View": [
            "PRODUCT",
            "CATEGORIES",
            "FACILITY",
            "SELLABLE",
            "ALLOCATED",
            "RESERVED",
            "ON HOLD",
            "REJECTED",
            "TOTAL",
            "INCOMING",
            "NSP",
            "AVG COST",
            "STOCK VALUE",
          ],
        },
      },
      ...boardViewForAllocation,
      completeListOfViews: [],
    },
    inventoryDetail: {
      listView: {
        nameOfViews: [],
        allItemsName: [
          "PRODUCT",
          "FACILITY",
          "QUANTITY",
          "ALLOCATED",
          "ALLOCATABLE",
          "BATCH NO",
          "SERIAL NO",
          "UOM",
          "UNIT COST",
          "OTHER COSTS",
          "TOTAL LANDED COSTS",
          "LOCATION",
          "ZONE",
          "STATUS",
          "CREATE DATE",
          "CREATED BY",
        ],
        allViews: {
          "Default View": [
            "PRODUCT",
            "FACILITY",
            "QUANTITY",
            "ALLOCATED",
            "ALLOCATABLE",
            "BATCH NO",
            "SERIAL NO",
            "UOM",
            "UNIT COST",
            "OTHER COSTS",
            "TOTAL LANDED COSTS",
            "LOCATION",
            "ZONE",
            "STATUS",
            "CREATE DATE",
            "CREATED BY",
          ],
        },
      },
      ...boardViewForAllocation,
      completeListOfViews: [],
    },
    inventoryTransactions: {
      listView: {
        nameOfViews: [],
        allItemsName: [
          "PRODUCT",
          "FACILITY",
          "QUANTITY",
          "SOH",
          "REASON",
          "REFERENCE",
          "DATE OF TRANSACTION",
        ],
        allViews: {
          "Default View": [
            "PRODUCT",
            "FACILITY",
            "QUANTITY",
            "SOH",
            "REASON",
            "REFERENCE",
            "DATE OF TRANSACTION",
          ],
        },
      },
      ...boardViewForAllocation,
      completeListOfViews: [],
    },
  },

  headersForInventoryDetails: [
    "PRODUCT",
    "DESCRIPTION",
    "FACILITY",
    "QUANTITY",
    "ALLOCATABLE QTY",
    "ALLOCATED QTY",
    "RESERVED QTY",
    "UNIT COST",
    "OTHER COSTS",
    "TOTAL LANDED COSTS",
    "CURE OVER",
    "INSPECTION",
    "ON HOLD",
    "PRODUCTION",
    "STATUS",
    "CREATED BY",
  ],
  headersForInventoryTransactions: [
    "PRODUCT",
    "FACILITY",
    "QUANTITY",
    "SOH",
    "REASON",
    "REFERENCE",
    "DATE OF TRANSACTION",
  ],
  singleView: {},
  consignmentMappedById: {},

  allFilterField: [],
  allFilterCondition: [],
  filteredConsignmentByRule: null,
};

const newWareHouseSlice = createSlice({
  name: "newWarehouse",
  initialState,
  reducers: {
    setAllViewsForWarehouse: (state, action) => {
      const { data, moduleType } = action.payload;
      const views = sortAllView(data);
      let module = "inventory";
      if (moduleType === "stock_line") {
        module = "inventoryDetail";
      } else if (moduleType === "stock_transaction") {
        module = "inventoryTransactions";
      }
      const mergedAllViews = {
        ...state.inventory[module].listView.allViews,
        ...views.list.allViews,
      };
      if (module === "inventory") {
        Object.keys(mergedAllViews).forEach(viewName => {
          mergedAllViews[viewName] = (mergedAllViews[viewName] || []).filter(
            column => column !== "PRODUCT NAME",
          );
        });
      }
      state.inventory[module] = {
        ...state.inventory[module],
        listView: {
          ...state.inventory[module].listView,
          nameOfViews: views.list.nameOfList,
          allViews: mergedAllViews,
        },

        completeListOfViews: data,
      };
    },
    setWarehouseCostingRangeLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.warehouseCostingRangeLayout = {
        ...state.warehouseCostingRangeLayout,
        listView: {
          ...state.warehouseCostingRangeLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.warehouseCostingRangeLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    setForecastLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.forecastLayout = {
        ...state.forecastLayout,
        listView: {
          ...state.forecastLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.forecastLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    setWarehouseCostingLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.warehouseCostingLayout = {
        ...state.warehouseCostingLayout,
        listView: {
          ...state.warehouseCostingLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.warehouseCostingLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    setStandardCostLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.standardCostLayout = {
        ...state.standardCostLayout,
        listView: {
          ...state.standardCostLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.standardCostLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    setStockZoneLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.stockZoneLayout = {
        ...state.stockZoneLayout,
        listView: {
          ...state.stockZoneLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.stockZoneLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },

    setStockLocationLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.stockLocationLayout = {
        ...state.stockLocationLayout,
        listView: {
          ...state.stockLocationLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.stockLocationLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    stockReplenishmentLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.stockReplenishmentLayout = {
        ...state.stockReplenishmentLayout,
        listView: {
          ...state.stockReplenishmentLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.stockReplenishmentLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    setPicklistLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.picklistLayout = {
        ...state.picklistLayout,
        listView: {
          ...state.picklistLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.picklistLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    setStockPackLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.stockPackLayout = {
        ...state.stockPackLayout,
        listView: {
          ...state.stockPackLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.stockPackLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },

    setSiteLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.siteLayout = {
        ...state.siteLayout,
        listView: {
          ...state.siteLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.siteLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },

    setWorkCenterLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.workCenterLayout = {
        ...state.workCenterLayout,
        listView: {
          ...state.workCenterLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.workCenterLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
  },
});

export const {
  setAllViewsForWarehouse,
  setWarehouseCostingRangeLayoutAllViews,
  setWarehouseCostingLayoutAllViews,
  setForecastLayoutAllViews,
  setStandardCostLayoutAllViews,
  setStockZoneLayoutAllViews,
  setStockLocationLayoutAllViews,
  stockReplenishmentLayoutAllViews,
  setPicklistLayoutAllViews,
  setStockPackLayoutAllViews,
  setSiteLayoutAllViews,
  setWorkCenterLayoutAllViews,
} = newWareHouseSlice.actions;

export default newWareHouseSlice.reducer;
